const defaultTo = (
  date: Date | null | undefined,
  defaultValue: string,
): string => {
  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    return date.toISOString().split('T')[0] // Format as 'YYYY-MM-DD'
  }
  return defaultValue
}

export const getDateToday = () =>
  defaultTo(new Date(), new Date().toISOString().split('T')[0])

export default getDateToday
